// Copyright ©️ 2026 eVolve MEP, LLC

import { AppShell, Burger, Group } from '@mantine/core';

import { EvolveLogoLink } from 'app/Layout/HeaderBar/components/EvolveLogoLink';
import { useAppShell } from 'app/Layout/NavBar/useAppShell';

export const MobileHeaderBar = () => {
  const { mobileNavOpened, toggleMobileNav } = useAppShell();

  return (
    <AppShell.Header bg="app-shell-gray.9" withBorder={false}>
      <Group h="100%" px="md" justify="space-between" align="center">
        <EvolveLogoLink disabled />
        <Burger
          opened={mobileNavOpened}
          onClick={toggleMobileNav}
          color="white"
          size="sm"
          aria-label="Toggle navigation"
        />
      </Group>
    </AppShell.Header>
  );
};
